import React from 'react';
import PropTypes from 'prop-types';
import { MessageAlert } from '../../typography';

function MTCaptcha(props) {
  const { style, siteKey, testKey, error } = props;

  React.useEffect(() => {
    if (siteKey) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.innerHTML = `
      var mtcaptchaConfig = {
        "sitekey": "${siteKey}",
      };`;
      document.body.appendChild(s);

      const mtService = document.createElement('script');
      mtService.src = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
      mtService.async = true;
      document.body.appendChild(mtService);

      const mtService2 = document.createElement('script');
      mtService2.src = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';
      mtService2.async = true;
      document.body.appendChild(mtService2);
    }
  }, [siteKey]);

  React.useEffect(() => {
    if (testKey) {
      if (window.mtcaptcha) {
        window.mtcaptcha.enableTestMode(testKey);
      }
    }
  }, [testKey]);

  // to avoid the captcha not being shown
  // if the script was already initialized
  React.useEffect(() => {
    if (window.mtcaptcha) window.mtcaptcha.renderUI();
  }, []);

  return (
    <div style={style}>
      <div className="mtcaptcha" />
      {error && <MessageAlert>{error}</MessageAlert>}
    </div>
  );
}

MTCaptcha.propTypes = {
  style: PropTypes.object,
  siteKey: PropTypes.string,
  testKey: PropTypes.string,
  error: PropTypes.string,
};

export default MTCaptcha;
